import Modal from '../alerts/modal.js';


var xhr_request = null;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

export default class Api {

  /**
   * Ajax action (general)
   *
   * @return {PROMISE}
   */
  ajaxRequest(method, url, data = {}, asJson = false)
  {
    const promise = $.Deferred();

    const params = {
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      dataType:'json',
      method:method,
      url:url,
      data: asJson ? JSON.stringify(data) : data,
      contentType: asJson ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8',
      success: function(response)
      {
        promise.resolve(response);
      },
      error: function(xhr, status, error)
      {
        var response = null;
        var responseText = (xhr && typeof xhr.responseText === 'string') ? xhr.responseText : '';

        if (xhr && xhr.responseJSON && typeof xhr.responseJSON === 'object') {
          response = xhr.responseJSON;
        } else if (responseText) {
          if (responseText.indexOf('<!DOCTYPE html>') !== -1) {
            response = {error:'Session timeout'};
          } else {
            try {
              response = JSON.parse(responseText);
            } catch (e) {
              response = {error: responseText};
            }
          }
        } else {
          response = {error: error || status || 'Network error'};
        }

        // Toast response?
        if (response.hasOwnProperty('toast') && !response.toast) {
          promise.reject(response);
          return;
        }

        var error = response.error || 'Unknown error';
        
        // Timeout?
        if (error === 'Session timeout') {
          location.reload();
          return;
        }

        // Specific modal params?
        if (response.hasOwnProperty('modal')) {
          if (response.modal.hasOwnProperty('html')) {
            response.modal.content = document.createElement("span");
            response.modal.content.innerHTML = response.modal.html;
          }
          (new Modal).show(response.modal);
        // Default modal?
        } else {
          var title = response.title || 'Error';
          (new Modal).error(title, error, 'Ok'); 
        }

        promise.reject(response);
      }
    }
    if (method === 'DELETE') {
      params['type'] = 'POST';
    }
    xhr_request = $.ajax(params);
    
    return promise;
  }


  /**
   * Make a POST request
   *
   * @return {PROMISE}
   */
  postRequest(url, data = {}, asJson = false)
  {
    return this.ajaxRequest('POST', url, data, asJson);
  }


  /**
   * Make a PATCH request
   *
   * @return {PROMISE}
   */
  patchRequest(url, data = {}) 
  {
    return this.ajaxRequest('PATCH', url, data);
  }


  /**
   * Make a GET request
   *
   * @return {PROMISE}
   */
  getRequest(url, data = {}) 
  {
    return this.ajaxRequest('GET', url, data);
  }

  /**
   * Make a DELETE request
   *
   * @return {PROMISE}
   */
  deleteRequest(url, data = {}) 
  {
    return this.ajaxRequest('DELETE', url, data);
  }

  /**
   * Make a PUT request
   *
   * @return {PROMISE}
   */
  putRequest(url, data = {}) 
  {
    return this.ajaxRequest('PUT', url, data);
  }


}